module.exports = __webpack_public_path__ + "img/q4-9.cd764f7a.png";